@use "ui/styles/colorsOld";
@use "ui/styles/fontsOld";
@use "ui/oldStyles/transitions";
@use "ui/oldStyles/utils";
@use "ui/styles/effects";
@use "ui/styles/studio";

.wrapper {
  position: relative;

  .flyoutButton {
    width: 16.5px;
    height: 16.5px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    transition: background transitions.$short;
    color: studio.$studioColor;

    &.flyoutButtonActive {
      background: studio.$studioColorSelected;
    }

    &:hover {
      background: studio.$studioHoverBackgroundColor;
      cursor: pointer;
    }
  }

  :global {
    .icon-open {
      background: studio.$studioColorSelected !important;
      border-radius: 3px;
      color: studio.$studioBackgroundColorLimit;
    }
  }
}

.flyoutMenu {
  display: inline-block;
  position: relative;
  width: fit-content;
  min-width: 242px;
  max-width: min(560px, calc(100vw - 24px), var(--available-width));
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  border: 1px solid studio.$studioBorderColor;
  background-color: studio.$studioBackgroundColor;
}

.isResizing {
  user-select: none;
}

.popoverContent {
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
  outline: none;

  &:focus,
  &:focus-visible {
    outline: none;
  }
}

.flyoutMenuHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: studio.$studioRowHeight;
  padding: studio.$studioRowPadding;
  border-bottom: 1px solid studio.$studioBorderColor;
  font-weight: fontsOld.$medium-weight;
  color: studio.$studioColor;

  > div:last-child {
    display: flex;
    align-items: center;
    gap: 4px;

    div {
      transition:
        background-color transitions.$short,
        color transitions.$short;
      width: 18px;
      height: 18px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background-color: studio.$studioHoverBackgroundColor;
        cursor: pointer;
      }
    }
  }
}

.flyoutMenuBody {
  @include effects.scrollbar;
  height: auto;
  max-height: none;
  overflow-x: hidden;
  overflow-y: visible;
  padding: 0 0 1em 0;
}

.flyoutMenuBodyContent {
  width: 100%;
}

.resizeHandleLeftEdge {
  position: absolute;
  top: 0;
  left: -4px;
  bottom: 0;
  width: 12px;
  cursor: ew-resize;
  z-index: 2;
  pointer-events: auto;
}
